import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getPublicationsRequest: ['page', 'category'],
  getPublicationsSuccess: ['data'],
  getPublicationsError: ['error'],
});

const INITIAL_STATE = Immutable({
  publishes: {},
  error: {},
});

const getPublicationsSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);
const getPublicationsError = (state = INITIAL_STATE, { error }) => state.set('error', error);

export default createReducer(INITIAL_STATE, {
  [Types.GET_PUBLICATIONS_SUCCESS]: getPublicationsSuccess,
  [Types.GET_PUBLICATIONS_ERROR]: getPublicationsError,
});
